<template>
    <div>
        <div class="titre contour_texte_chronologie">Chronologie</div>
        <div class="container_volet chronologie">
            <div class="container-bubbles">
                <div class="year" v-for="year in years" :id="'year-'+year.number">
                    <div class="bubble" v-for="file in year.files" v-on:click="$router.push(url_base+'chronologie/'+file.slug)">
                        <div class="bubble-spot"><p>{{ file.titre }}</p></div>
                    </div>
                    <div class="year-label">{{ year.number }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { state } from '../../main.js';
import { url_liste_objets, url_base } from '../../variables.js';

export default {
    data() {
        return {
            url_base:url_base,
            fiches: state.fiches,
            mots_clefs: state.mots_clefs,
            mode_click: false,
            mot_actif:""
        }
    },

    computed: {   
        fiches_triees: function() {
            return this.fiches.filter(function(item) {
                //console.log(item);
                if (item.masquer != false) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        years : function(){
            var arr = {};
            var files = this.fiches;
            for(var f = 0; f < files.length; ++f){
                var y = parseInt(files[f].annee);

                if(arr[y]){
                    if(files[f].masquer){}else{
                        arr[y].files.push(files[f]);
                    }
                }else{
                    arr[y] = {
                        number : y,
                        files : []
                    };
                    arr[y].files.push(files[f]);
                }
            }
            //reverse arr
            return arr;
        }
    },
    mounted : function(){
        var years = document.getElementsByClassName("year");
        var sizes = [];
        for(var y = 0; y < years.length; ++y){
            var s = years[y].getElementsByClassName("bubble").length;
            sizes.push(s);
            if(years[y].getElementsByClassName("bubble").length < 1){
                years[y].style.display = "none";
            }
        }
        var size_mini = 15, size_max = Math.max(...sizes), size_def = 0;
        //console.log(size_mini,"/",size_max);
        if(size_max > size_mini){
            size_def = size_max;
        }else{
            size_def = size_mini;
        }
        for(var y = 0; y < years.length; ++y){
            years[y].style.gridTemplateColumns = "repeat("+size_def+",calc((100vw /"+size_def+") - 12px))";
        }
        for(var b = 0; b < document.getElementsByClassName("bubble").length; ++b){
            document.getElementsByClassName("bubble")[b].style.height = "calc((100vw /"+size_def+") - 12px)";
        }
    },

    methods: {}
};


</script>

<style>
    :root{
        /*--bubble-width: 160px;*/
        --bubble-width: calc((100vw /10) + 12px);
    }
    .contour_texte_chronologie {
        text-shadow:
            -2px -2px 0 var(--couleur-chronologie),
            2px -2px 0 var(--couleur-chronologie),
            -2px 2px 0 var(--couleur-chronologie),
            2px 2px 0 var(--couleur-chronologie);
    }
    .chronologie {
        background-color: var(--couleur-chronologie);
    }
    .container_volet .chronologie{
        width: 100%!important;
    }
    .container-bubbles{
        margin-top: 10vh;
        padding-left: var(--lrm);
        padding-bottom: 10vh;
        display: flex;
        flex-direction: column-reverse;
    }
    .year{
        width: 100%;
        height: auto;
        display: grid;
        grid-template-columns: repeat(15,calc((100vw /15) - 12px));
    }
    .bubble, .year-label{
        border-radius: 100%;
        width: 100%;
        height: calc((100vw /15) - 12px);
        display: flex;
    }
    .volet.replie .bubble{
        pointer-events: none;
    }
    .bubble{
        background-color: black;
        color: white;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        pointer-events: all;
    }
    .bubble-spot{
        position: absolute;
        width: var(--bubble-width); height: var(--bubble-width);
        background-color: white;
        color: black;
        border-radius: 100%;
        display: none;
        pointer-events: none;
        overflow-wrap: break-word;
    }
    .bubble-spot p{
        max-width: calc(var(--bubble-width) - 20px);
        max-height: calc(var(--bubble-width) - 20px);
        background-color: transparent;
        text-align: center;
        /*word-break: break-word;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;*/
        float: left;
        /*overflow-wrap: break-word;
        -webkit-line-clamp: 3;
        hyphens: auto;*/
        word-break: keep-all;
        white-space: normal;
        pointer-events: none;
        /*max-width: 30px;*/
    }
    .bubble:hover .bubble-spot{
        display: flex;
        justify-content: center;
        align-items: center;
        pointer-events: all;

    }
    .year-label{
        justify-content: flex-start;
        align-items: center;
        padding-left: 12px;
    }
</style>